/** Templates */
import pacePaymentDialogTemplate from './pacePaymentDialog.html';
/** Styles */
import './pacePaymentDialog.scss';

/*******************************************************************************
 * Pace Payment Dialog
 *******************************************************************************/
/*------------------------------------------------------------*/
/* Style file to pass to Pace for use in styling PaymentFrame */
/* fields. Must be in the same folder as this script.         */
/*------------------------------------------------------------*/
var PaymentFrameCSS = 'pacePaymentFrame.iframe.css';

/*-----------*/
/* Directive */
/*-----------*/
export function pacePaymentDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    scope: {
      config: '<',
      cartTotal: '<',
      onClick: '&',
      onCommit: '&',
      onFail: '&'
    },
    template: pacePaymentDialogTemplate,
    backdrop: 'static',
    windowClass: 'payment-card-dialog pace-payment-dialog',
    controller: controller,
    preloader: preloader
  });
}

pacePaymentDialogDirective.$inject = ['ClickDialogDirective'];

/*-----------------------------------------*/
/* Preloader passes `$cssURL` to `onClick` */
/* for use in payment frame configuration. */
/*-----------------------------------------*/
/* @ngInject */ function preloader($scope, AssetFiles, DOMTools) {
  var cssFile = AssetFiles[PaymentFrameCSS] || PaymentFrameCSS;
  /**
   * We want to provide PACE with the location of our CSS file for styling the
   * PaymentFrame IFRAME fields. This file is located in the "dist" folder
   * alongside our other built assets.
   *
   * The url will look like this:
   * https://your-domain/store/client/dist/pacePaymentFrame.iframe.css
   */
  var cssURL = `${window.location.origin}/store/client/dist/${cssFile}`;
  return $scope.onClick({ $cssURL: cssURL });
}

/*------------*/
/* Controller */
/*------------*/
/* @ngInject*/ function controller(
  $scope,
  $uibModalInstance,
  $injector,
  $q,
  $preloaded,
  Alert
) {
  var $svcs = {
    $ctrl: this,
    $scope: $scope,
    $uibModalInstance: $uibModalInstance,
    $preloaded: $preloaded
  };
  var $ctrl = $injector.invoke(
    init$ctrl,
    null,
    ($svcs = Object.assign($svcs, { $svcs: $svcs }))
  );
  var pageReady = $injector.invoke(initPage, null, $svcs);

  /*------------------------------------------*/
  /* Get `PaymentCardDialog' validator method */
  /* for validation of billing address info.  */
  /*------------------------------------------*/
  $ctrl.dialogLoaded = function ($validator) {
    $ctrl.validateDialog = $validator;
  };

  /*----------------------------------------*/
  /* Initialize PaymentFrame when PACE JS   */
  /* is loaded and dialog form is rendered. */
  /*----------------------------------------*/
  $q.all([pageReady, $uibModalInstance.rendered])
    .then(function () {
      return (
        $injector
          .invoke(initPaymentFrame, null, $svcs)
          .then(() => {
            $ctrl.payframeReady = true;

            /*-----------------------------------------------*/
            /* Load complete/cancel page when dialog closes. */
            /*-----------------------------------------------*/
            $uibModalInstance.result
              .then(() => (window.location.href = $preloaded.returnURL))
              .catch(() => (window.location.href = $preloaded.cancelURL));
          })
          /**
           * This catch was added for GR-1784 to alert users to any payment frame
           * issues which may occur. Previously any errors would bubble up to the
           * $ctrl.onFail which would tell the user it was a server error and kick
           * them out of the app.
           * We check for the error string first to ensure that we arent displaying
           * something odd to the customer here.
           */
          .catch((e) => {
            console.error('Caught in initPaymentFrame', e);
            const isString = typeof e === 'string';
            Alert.error(isString ? e : '', 'Error Loading Payment Screen');
            $uibModalInstance.close();
          })
      );
    })

    /*-------------------------------------------------------------*/
    /* Call fail handler if checkout process could not be started. */
    /*-------------------------------------------------------------*/
    .catch((reason) => {
      $uibModalInstance.dismiss();
      $ctrl.onFail({ $reason: reason });
    });
}

/*******************************************************************************
 * init$ctrl */
/**
 * $ctrl property initializer.
 *
 * @param  $ctrl  Controller object.
 * @param  $svcs  Properties to pass with `$injector.invoke()`.
 * @return $ctrl
 *******************************************************************************/
/* @ngInject */ function init$ctrl($svcs, $ctrl, $injector, PaymentsData) {
  return Object.defineProperties(
    Object.assign($ctrl, {
      /*----------*/
      /* Handlers */
      /*----------*/
      submit: $injector.invoke(submit, null, $svcs),

      /*---------------------*/
      /* Billing info model. */
      /*---------------------*/
      billingInfo: new PaymentsData.pace.BillingInfo(),

      /*-------------------------------------------*/
      /* payframeElement - Payment Frame IFRAME    */
      /* element. For submitting card info fields. */
      /*-------------------------------------------*/
      payframeElement: null,

      /*--------------------------------------*/
      /* payframeObject - PACE `PaymentFrame` */
      /* instance from IFRAME registration.   */
      /*--------------------------------------*/
      payframeObject: null,

      /*---------------------------------------------------------------*/
      /* payframeReady - `true` when payment frame is ready for input. */
      /*---------------------------------------------------------------*/
      payframeReady: false,

      /*-------------------------------------------------*/
      /* waitingForToken - Set when payfields button is  */
      /* clicked and cleared on token generation result. */
      /*-------------------------------------------------*/
      waitingForToken: false
    }),

    /*-----------*/
    /* Accessors */
    /*-----------*/
    {
      /*-----------------------------------*/
      /* readyForInput - Hides busy panel. */
      /*-----------------------------------*/
      readyForInput: {
        get: function () {
          return $ctrl.payframeReady && !$ctrl.waitingForToken;
        }
      }
    }
  );
}

/*******************************************************************************
 * initPage */
/**
 * Loads browser page resources. Loads PACE javascript file and returns
 * `window.checkoutReady` as a promise resolved when load is complete.
 *
 * @returns {Promise} Resolved when page resources have been loaded.
 *                    Rejected if script fails to load.
 *******************************************************************************/
/* @ngInject */ function initPage($ctrl, $interval, $q) {
  /*--------------------------------------------*/
  /* Do not load script file if already loaded. */
  /*--------------------------------------------*/
  if (!window.checkoutReady) {
    /*------------------------------------------*/
    /* Add script tag to load the PaymentFrame  */
    /* javascript and add load/error listeners. */
    /*------------------------------------------*/
    var head = document.querySelector('head');
    var script = document.createElement('script');
    script.src = $ctrl.config.scriptURL;
    script.addEventListener('load', () => (window.scriptLoaded = true));
    script.addEventListener('error', () => (window.scriptLoaded = false));
    head.appendChild(script);

    window.checkoutReady = $q(function (resolve, reject) {
      var timer = $interval(
        function () {
          if (!angular.isUndefined(window.scriptLoaded)) {
            $interval.cancel(timer);

            if (window.scriptLoaded)
              if (window.PaymentFrame) resolve();
              else
                reject(`Script file '${$ctrl.config.scriptURL}' is not valid.`);
            else
              reject(
                `Script file '${$ctrl.config.scriptURL}' could not be loaded.`
              );
          }
        },
        100,
        100,
        false
      );
    });
  }

  return window.checkoutReady;
}

/*******************************************************************************
 * initPaymentFrame */
/**
 * Configures PACE PaymentFrame IFRAME element, registers the IFRAME with PACE
 * js, and waits for IFRAME `style` property to be set, indicating the IFRAME is
 * ready for input.
 *
 * @returns {Promise} Resolved when Payment Frame is ready for input.
 *******************************************************************************/
/* @ngInject */ function initPaymentFrame($ctrl, $interval, $q, $preloaded) {
  var frameID = 'payment-frame';

  /*-----------------------------------------------------------*/
  /* Find payment frame and add attributes from configuration. */
  /*-----------------------------------------------------------*/
  $ctrl.payframeElement = document.getElementById(frameID);

  for (
    var re = /(?:^| )([\w-]+)="(.+?)"/g, m;
    (m = re.exec($preloaded.frameAttrs)) !== null;

  )
    $ctrl.payframeElement.setAttribute(m[1], m[2]);

  /*--------------------------------------------------------------*/
  /* Add onload listener to the IFRAME to set a flag when the     */
  /* IFRAME is loaded. This handler will be called even when      */
  /* there is an error. There is no 'error' event with an IFRAME. */
  /*--------------------------------------------------------------*/
  delete window.frameLoaded;
  var loadHandler = () => (window.frameLoaded = true);

  $ctrl.payframeElement.addEventListener('load', loadHandler);

  /*----------------------------------------------------*/
  /* Initialize PaymentFrame through PACE js and return */
  /* a promise resolved when it's ready for input.      */
  /*----------------------------------------------------*/
  $ctrl.payframeObject = new PaymentFrame(frameID, $ctrl.config.paymentHost);
  $ctrl.payframeObject.request();

  return $q(function (resolve, reject) {
    /*----------------------------------*/
    /* Wait for the frame 'load' event. */
    /*----------------------------------*/
    var timer = $interval(
      function () {
        if (window.frameLoaded) {
          $interval.cancel(timer);

          /*------------------------------------------*/
          /* Wait for IFRAME to get 'style' attribute */
          /* set by PACE JS and resolve the promise.  */
          /*------------------------------------------*/
          timer = $interval(
            function () {
              if ($ctrl.payframeElement.getAttribute('style') != null) {
                $interval.cancel(timer);
                resolve();
              }
              // every 40ms, for 50 times = total of 2 second
              // wait time to initialize PaymentFrame
            },
            40,
            50,
            false
          );

          /*------------------------------------------------------*/
          /* If the timer runs out, PACE JS did not set the style */
          /* attribute so something must be wrong. Most likely,   */
          /* the credentials are not valid for Payment Frame.     */
          /*------------------------------------------------------*/
          timer.then(() => reject(`PaymentFrame did not activate.`));
        }
      },
      100,
      100,
      false
    );

    /*----------------------------------------------------*/
    /* If the timer runs out, the load event never fired. */
    /*----------------------------------------------------*/
    timer.then(() => reject('PaymentFrame could not be loaded.'));

    /*---------------------------------------*/
    /* Remove the IFRAME load event handler. */
    /*---------------------------------------*/
    timer.finally(() =>
      $ctrl.payframeElement.removeEventListener('load', loadHandler)
    );
  });
}

/*****************************************************************************
 * $ctrl.submit */
/**
 * Submit button handler. Submits card info to PACE and waits for a response.
 * If response is "AUTH" and the address fields are valid, the generated ticket
 * (token) is used to create a sale on the server.
 *
 * PACE will not respond if the card info fields are empty and will respond
 * with "DENY" if the input is not valid. We use a timeout to handled the empty
 * fields case and if, for some reason, the timeout hits before a PACE response,
 * validation will be performed twice but will have no ill effect.
 *
 * @param {object} data  Event info. `undefined` if submit button.
 *****************************************************************************/
/* @ngInject */ function submit($ctrl, $timeout, $uibModalInstance) {
  return function () {
    $ctrl.waitingForToken = true;

    /*----------------------------------------------------------------*/
    /* Set timeout to call `handleResponse` if PACE does not respond. */
    /*----------------------------------------------------------------*/
    var stop = $timeout(handleResponse, 2000);

    /*-------------------------------------------------------*/
    /* Submit the card info fields to PACE. Stop the timeout */
    /* and call `handleResponse` if there is a response.     */
    /*-------------------------------------------------------*/
    $ctrl.payframeObject.setPaymentSubmittedCallback(function (r) {
      $timeout.cancel(stop);
      $timeout(function () {
        handleResponse(r);
      });
    });

    $ctrl.payframeElement.contentWindow.postMessage(
      JSON.stringify({ type: 'submitPaymentData' }),
      $ctrl.config.paymentHost
    );

    /*----------------*/
    /* handleResponse */
    /*----------------*/
    function handleResponse(r) {
      console.log(r);
      $ctrl.waitingForToken = false;

      /*-------------------------------------------------------------*/
      /* Clear the callback. A new `payframeObject` is created       */
      /* whenever the dialog is shown. If the user cancels or gets a */
      /* decline, and clicks the button that shows the dialog again, */
      /* old callbacks will be called if they are not cleared.       */
      /*-------------------------------------------------------------*/
      $ctrl.payframeObject.setPaymentSubmittedCallback(null);

      /*------------------------------*/
      /* Call payment card validator. */
      /*------------------------------*/
      if ($ctrl.validateDialog(r && r.code == 'AUTH')) {
        $ctrl.billingInfo.cardToken = r.ticket;
        $ctrl.billingInfo.cardType = r.cardtype;

        $ctrl.onCommit({ $billingInfo: $ctrl.billingInfo }).then(function (r) {
          console.log(r);
          $uibModalInstance.close();
        });
      }
    }
  };
}
